var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 13.8333H3.33333L10.5208 6.64584L9.35417 5.47917L2.16667 12.6667V13.8333ZM14.0833 5.43751L10.5417 1.93751L11.7083 0.770838C12.0278 0.451394 12.4201 0.291672 12.8854 0.291672C13.3507 0.291672 13.7431 0.451394 14.0625 0.770838L15.2292 1.93751C15.5486 2.25695 15.7153 2.64237 15.7292 3.09376C15.7431 3.54514 15.5903 3.93056 15.2708 4.25001L14.0833 5.43751ZM1.33333 15.5C1.09722 15.5 0.899306 15.4201 0.739583 15.2604C0.579861 15.1007 0.5 14.9028 0.5 14.6667V12.3125C0.5 12.2014 0.520833 12.0938 0.5625 11.9896C0.604167 11.8854 0.666667 11.7917 0.75 11.7083L9.33333 3.12501L12.875 6.66667L4.29167 15.25C4.20833 15.3333 4.11458 15.3958 4.01042 15.4375C3.90625 15.4792 3.79861 15.5 3.6875 15.5H1.33333Z",
    fill: "var(--primary-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4687c2f8d67b1c6eb00b34d85ace3a49.svg";
export { ForwardRef as ReactComponent };